import type { DesktopMenu, OpenMenu } from './type';

export function toggleMenu(current: OpenMenu, menu: DesktopMenu): OpenMenu {
  return current === menu ? null : menu;
}
